var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"no-margin-top":"","title":"Problemas e/ou condições - EMAD","type":"fieldset"}},[(_vm.item.avaliacao.condicoesEmad.length > 0)?_c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('Item',{attrs:{"get-value":() => _vm.item.avaliacao.condicoesEmad.join(', ')}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }